/* eslint-disable import/prefer-default-export */
import { TAB_PCB_PARTS } from 'project_quote/data/tabTypes';
import { openModal, updateShowBomSelection } from 'pcb-parts/slice/bomSlice';
import { selectDataForBomTabChange } from 'pcb-parts/slice/selectors';

export const processTabChange = (tab) => async (dispatch, getState) => {
  const {
    available_bom_in_zip,
    bom_saved,
    bom_selected,
    changed_zip_file,
    uploaded_zip_file,
  } = selectDataForBomTabChange(getState());

  if (tab !== TAB_PCB_PARTS) return;

  if (bom_saved && !changed_zip_file) return;

  if (uploaded_zip_file && available_bom_in_zip && !bom_selected) {
    dispatch(updateShowBomSelection(true));
    return;
  }

  if (bom_selected) dispatch(openModal());
};
